export const SANDPACK_EXTERNAL_RESOURCES = [`https://appkitcdn.pwc.com/appkit4/cdn/styles/4.11.0/appkit.min.css`];

const PWC_LOGO_LIGHT_URI = 'https://appkitcdn.pwc.com/appkit4/cdn/styles/4.11.0/images/PwC_logo_new.svg';
const PWC_LOGO_DARK_URI = 'https://appkitcdn.pwc.com/appkit4/cdn/styles/4.11.0/images/PwC_logo_dark_new.svg';

function buildIconFontCss(origin: string): string {
    const fi = (name: string) => `${origin}/font-icon/font/${name}`;

    return `@font-face{font-family:"appkit4-font";src:url("${fi('appkit4-font.eot?75669683')}");src:url("${fi('appkit4-font.eot?75669683#iefix')}") format("embedded-opentype"),url("${fi('appkit4-font.woff2?75669683')}") format("woff2"),url("${fi('appkit4-font.woff?75669683')}") format("woff"),url("${fi('appkit4-font.ttf?75669683')}") format("truetype"),url("${fi('appkit4-font.svg?75669683#appkit4-font')}") format("svg");font-weight:normal;font-style:normal}`;
}

function buildITCCharterCss(origin: string): string {
    const f = (name: string) => `${origin}/font/${name}`;

    return [
        `@font-face{font-family:"ITCCharter";src:url("${f('ITCCharter-Regular.woff2')}") format("woff2"),url("${f('ITCCharter-Regular.ttf')}") format("truetype");font-weight:400;font-style:normal;font-display:swap}`,
        `@font-face{font-family:"ITCCharter";src:url("${f('ITCCharter-Italic.woff2')}") format("woff2"),url("${f('ITCCharter-Italic.ttf')}") format("truetype");font-weight:400;font-style:italic;font-display:swap}`,
        `@font-face{font-family:"ITCCharter";src:url("${f('ITCCharter-Bold.woff2')}") format("woff2"),url("${f('ITCCharter-Bold.ttf')}") format("truetype");font-weight:700;font-style:normal;font-display:swap}`,
        `@font-face{font-family:"ITCCharter";src:url("${f('ITCCharter-BoldItalic.woff2')}") format("woff2"),url("${f('ITCCharter-BoldItalic.ttf')}") format("truetype");font-weight:700;font-style:italic;font-display:swap}`,
    ].join('');
}

const FONT_FIX_MODULE_TEMPLATE = `var css = __CSS_PLACEHOLDER__;
var s = document.createElement("style");
s.setAttribute("data-appkit-font-fix", "true");
s.textContent = css;
setTimeout(function(){ document.head.appendChild(s); }, 0);
`;

function buildLogoCss(): string {
    return [
        `.ap-header-logo.ap-header-logo.ap-header-logo.ap-header-logo.ap-header-logo{background:url("${PWC_LOGO_LIGHT_URI}") no-repeat center/contain !important}`,
        `[data-mode="dark"] .ap-header-logo.ap-header-logo.ap-header-logo.ap-header-logo.ap-header-logo,[data-mode="dark-hc"] .ap-header-logo.ap-header-logo.ap-header-logo.ap-header-logo.ap-header-logo{background:url("${PWC_LOGO_DARK_URI}") no-repeat center/contain !important}`,
    ].join('');
}

function buildFontFixModule(origin: string, designSystem?: string): string {
    let css = buildIconFontCss(origin);
    if (designSystem === 'NewEra') {
        css += buildITCCharterCss(origin);
    }
    css += buildLogoCss();
    const escaped = css.replace(/\\/g, '\\\\').replace(/`/g, '\\`').replace(/\$/g, '\\$');
    return FONT_FIX_MODULE_TEMPLATE.replace('__CSS_PLACEHOLDER__', '`' + escaped + '`');
}

const FONT_FIX_FILE = '/__appkit_font_fix.js';
const ENTRY_CANDIDATES = ['/index.tsx', '/index.js', '/src/index.tsx', '/src/index.js'];

export function injectFontFix(files: Record<string, any>, designSystem?: string): Record<string, any> {
    const origin = window.location.origin;
    const result = { ...files };

    result[FONT_FIX_FILE] = { code: buildFontFixModule(origin, designSystem) };

    const importLine = `import "${FONT_FIX_FILE}";\n`;
    for (const entry of ENTRY_CANDIDATES) {
        if (result[entry]) {
            const val = result[entry];
            const code = typeof val === 'string' ? val : val?.code;
            if (typeof code === 'string' && !code.includes(FONT_FIX_FILE)) {
                const updated = importLine + code;
                result[entry] = typeof val === 'string' ? updated : { ...val, code: updated };
            }
            break;
        }
    }

    return result;
}
